webpackJsonp(["pages.help.index"],{

/***/ "./docs/docs_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);


function addMousetrapClick(el, key) {
  el.addEventListener('click', function () {
    return __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.trigger(key);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  addMousetrapClick(document.querySelector('.js-trigger-shortcut'), '?');
  addMousetrapClick(document.querySelector('.js-trigger-search-bar'), 's');
});

/***/ }),

/***/ "./pages/help/index/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version_check_image__ = __webpack_require__("./version_check_image.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_docs_bundle__ = __webpack_require__("./docs/docs_bundle.js");



document.addEventListener('DOMContentLoaded', function () {
  Object(__WEBPACK_IMPORTED_MODULE_1__docs_docs_bundle__["a" /* default */])();
  __WEBPACK_IMPORTED_MODULE_0__version_check_image__["a" /* default */].bindErrorEvent($('img.js-version-status-badge'));
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./version_check_image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VersionCheckImage = function () {
  function VersionCheckImage() {
    _classCallCheck(this, VersionCheckImage);
  }

  _createClass(VersionCheckImage, null, [{
    key: 'bindErrorEvent',
    value: function bindErrorEvent(imageElement) {
      imageElement.off('error').on('error', function () {
        return imageElement.hide();
      });
    }
  }]);

  return VersionCheckImage;
}();

/* harmony default export */ __webpack_exports__["a"] = (VersionCheckImage);

/***/ })

},["./pages/help/index/index.js"]);


// WEBPACK FOOTER //
// pages.help.index.9022fb8c49f52c2b1d07.bundle.js